import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';

export default class ThePortals extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
      text: (<div>The PORTALS</div>),
      text_plainText: "The PORTALS",
      textcopy: (<div>Her father Uranus addressed her about the dream she had and said he only could allow such dream come true if she developed only one way to enter the dreamland which only a few mortals souls could enter. Since then, the Portals are the only way to get in Mnemosyne Metaverse.</div>),
      textcopy_plainText: "Her father Uranus addressed her about the dream she had and said he only could allow such dream come true if she developed only one way to enter the dreamland which only a few mortals souls could enter. Since then, the Portals are the only way to get in Mnemosyne Metaverse.",
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  render() {
    const style_elBackground = {
      width: '100%',
      height: '100%',
     };
    const style_elBackground_outer = {
      boxSizing: 'border-box',
      backgroundColor: 'black',
     };
    const style_elText = {
      fontSize: 60.0,
      color: '#fffefe',
      textAlign: 'left',
     };
    const style_elTextCopy = {
      fontSize: 24.0,
      color: '#fffefe',
      textAlign: 'left',
     };
    
    return (
      <div className="ThePortals">
        <div className="background">
          <div className="containerMinHeight elBackground" style={style_elBackground_outer}>
            <div style={style_elBackground} />
          </div>
        </div>
        
        <div className="layoutFlow">
          <div className="elText">
            <div className="font-caesarDressingRegular" style={style_elText}>
              <div>{this.state.text}</div>
            </div>
          </div>
          
          <div className="elTextCopy">
            <div className="font-caesarDressingRegular" style={style_elTextCopy}>
              <div>{this.state.textcopy}</div>
            </div>
          </div>
        </div>
        
      </div>
    )
  }
  
}
